export default __webpack_public_path__ + "static/media/color-03.babf059e.svg";